import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_EASY_ASSISTANT_API_URL,
  headers: {
    'X-API-KEY': process.env.REACT_APP_API_KEY
  }
});


export default apiClient;